import React, { useEffect, useState } from 'react'
import Tabs from 'components/shared/Tabs'
import Button from 'components/shared/Button'
import Pagination from 'components/shared/Pagination'
import useGetIndexByQueryPaginated from 'sdk/hooks/search/useGetIndexByQueryPaginated'
import AssetRequestModal from 'modules/post/pages/CreatePost/EditForm/AssetRequestModal'
import styles from './styles.module.scss'
import AssetsTable from './AssetsTable'
import NotFound from './NotFound'

enum View { All, Stocks, ETFs, Crypto, NFT }
const items = [
  { title: 'All', id: View.All },
  { title: 'Stocks', id: View.Stocks },
  { title: 'ETFs', id: View.ETFs },
  { title: 'Crypto', id: View.Crypto },
]

type Props = { search: string }

export function TabAsset({ search }: Props) {
  const [view, setView] = useState<View>(View.All)
  const selectedCategory = items?.find((i) => i.id === view)?.title
  const [isAssetRequestVisible, setAssetRequestVisible] = useState(false)
  const [searchData, setSearchData] = useState<any[] | null>(null);
  const [page, setPage] = useState(0);
  const [total, setTotal] = useState(1);

  const {
    mutate: getIndex,
    data, isLoading, isSuccess,
  } = useGetIndexByQueryPaginated()

  const {
    mutate: getDefaultIndex,
    data: defaultData,
    isLoading: isLoadingDefaulData,
  } = useGetIndexByQueryPaginated()

  useEffect(() => {
    if (search !== undefined) {
      getDefaultIndex({
        query: '',
        index: 'assets',
        category: selectedCategory === 'All' ? '' : selectedCategory,
        page: 0,
      })
    }
  }, [])

  useEffect(() => {
    if (search !== undefined) {
      getIndex({
        query: search, index: 'assets', category: selectedCategory === 'All' ? '' : selectedCategory, page,
      })
    }
  }, [search, view, page])

  useEffect(() => {
    setPage(0)
  }, [view])

  useEffect(() => {
    if (isSuccess) { // @ts-ignore
      setSearchData(data?.data) // @ts-ignore
      setTotal(data?.pagination?.total)
    }
  }, [data, isSuccess])

  return (
    <div>
      <Tabs
        className={styles.tabs}
        items={items}
        onSelect={setView}
        value={view}
        simple
      />
      <div className={styles.main}>
        <AssetsTable data={searchData} loading={isLoading} />
        { data && (
        <Pagination
          page={page}
          pageCount={total}
          onPageChange={(p) => setPage(p)}
        />
        ) }
        { // @ts-ignore
          (!data?.data?.length && !isLoading) && <div className={styles.NotFound}><NotFound /></div>
        }
        <Button success className={styles.assetBtn} onClick={() => setAssetRequestVisible(true)}>
          Request a new asset
        </Button>
        {
          // @ts-ignore
          !data?.data?.length && (
            <div className={styles.available}>
              <h3 style={{ color: '#fff' }}>
                Check out available Assets
              </h3>
              <AssetsTable
          // @ts-ignore
                data={defaultData?.data.slice(0, 4)}
                loading={isLoadingDefaulData}
              />
            </div>

          )
        }
      </div>
      {isAssetRequestVisible ? (
        <AssetRequestModal onClose={() => setAssetRequestVisible(false)} />
      ) : null}
    </div>
  )
}
